/**
 * Tool result query operations - Delete
 */

import { getSupabaseClient } from '../../supabase-client';
import { logger } from '../../../logger';

/**
 * Delete a tool result
 */
export async function deleteToolResult(toolResultId: string): Promise<void> {
  try {
    const client = getSupabaseClient();

    const { error } = await client
      .from('meridian_tool_results')
      .delete()
      .eq('id', toolResultId);

    if (error) {
      throw error;
    }
  } catch (error) {
    logger.error('error deleting tool result', error, { op: 'deleteToolResult' });
    throw error;
  }
}
